/**
 * 
 * Usage:
 * 
 * 
 * given html in format:
 * 
 * 		<input type="checkbox" id="mybtn"/>
 * 		<div class="screen-options">
 * 			<!-- radios, selectors, inputs... -->
 * 		</div>
 * 
 * call screenOptionsBox on the checkbox:
 * 
 * 		$("#mybtn").screenOptionsBox();
 * 
 * 
 */
(function($){
	
	$.widget("ui.screenOptionsBox", {
		
		defaults: {
			
		},
		
		_create: function() {

			var checkbox = this.element,
			screenOptions = $(".screen-options");
			
			if(!(screenOptions && checkbox)){
				console.error('Could not init screen options, could not find checkbox or screen options');
				return;
			}
			
			// hide screen options on load
			screenOptions.hide(); 	
			
			// bind show/hide screen options
			checkbox.change(function(){
				if(checkbox.is(":checked")){
					screenOptions.slideDown("fast");
				}else{
					screenOptions.slideUp();
				}
			});
			
		}
		
	});
	
})(jQuery);
